export const FALLBACK_LANGUAGES = ['de', 'en'] as const;

export function getAvailableLanguages(configuredLanguages?: string): string[] {
  const languages = configuredLanguages?.split(/\s+/).filter(Boolean) ?? [];
  return languages.length > 0 ? languages : [...FALLBACK_LANGUAGES];
}
